import React from 'react'
import { PresalesContextProvider } from '@/contexts/PresaleContext'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { BaseLayout } from '../BaseLayout'

interface PresalesLayoutProps {
  children: React.ReactNode
  isDarkMode: boolean
  title?: string
}

export const PresalesLayout: React.FC<PresalesLayoutProps> = ({ children, isDarkMode }) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <PresalesContextProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <div>{children}</div>
        </ErrorBoundary>
      </PresalesContextProvider>
    </BaseLayout>
  )
}
